// JSON ingest path for the import wizard.
//
// The parser type is selected by enabled JSON-import feature flags and sent as
// the endpoint discriminator. The UI only uploads the file and identifiers, then
// redirects to the async job. Structured axios errors (`err.response.data`, a
// string or `{ error }`) are unwrapped before re-throwing so the operator sees
// the upstream message rather than a generic status error.
import { uploadJson } from '../queries/uploadJson';

export async function processOrdersFromJSON({ jsonFile, filename, userId, type }) {
    try {
        if (!type) {
            throw new Error('No JSON import type is enabled for this account.');
        }

        const resp = await uploadJson({
            shipperId: userId,
            type,
            filename,
            jsonFile,
        });

        const jobId = resp?.data?.job_id;
        if (!jobId) {
            throw new Error('Unable to start the JSON import. Please try again or contact support.');
        }

        return {
            ...resp.data,
            job_id: jobId,
        };
    } catch (err) {
        const responseError = err?.response?.data;
        const message =
            (typeof responseError === 'string' ? responseError : responseError?.error) ||
            err?.message ||
            'Error processing JSON';
        throw new Error(message);
    }
}
